import { useState, useCallback } from 'react'

import { CheckCircle2, AlertTriangle } from 'lucide-react'
import { cn } from '@/core/lib/utils'

export function useToast() {
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' } | null>(null)

  const show = useCallback((message: string, type: 'success' | 'error' = 'success') => {
    setToast({ message, type })
    setTimeout(() => setToast(null), 3000)
  }, [])

  const ToastUI = toast ? (
    <div
      className={cn(
        'fixed bottom-6 right-6 z-[100] flex items-center gap-2 rounded-xl px-4 py-3 shadow-lg border text-sm font-medium animate-in slide-in-from-bottom-2',
        toast.type === 'success'
          ? 'bg-green-50 border-green-200 text-green-700'
          : 'bg-red-50 border-red-200 text-red-700'
      )}
    >
      {toast.type === 'success' ? <CheckCircle2 className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
      {toast.message}
    </div>
  ) : null

  return { show, ToastUI }
}
